'use strict';

var baseSearch = require('base/search/search.js');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });
    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.js-reset-btn',
        '.js-no-search-results'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    // $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            // $.spinner().stop();
        },
        error: function () {
            // $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Show second image on hover in PLP
 */
baseSearch.showSecondImage = function(){
    $('.product-tile').on('mouseover', 
        function () {
            var imageEl = $(this).find('.image-container .tile-image');
            var secondImage = imageEl.data('secondimage');
            if (secondImage != null && secondImage != "") {
                // set new images
                imageEl.attr('src', secondImage);
            }
        }
    );
    $('.product-tile').on('mouseout', 
        function () {
            var imageEl = $(this).find('.image-container .tile-image');
            var ogImage = imageEl.data('ogimage');
            if (ogImage != null && ogImage != "") {
                // set new images
                imageEl.attr('src', ogImage);
            }
        }
    );
};

baseSearch.applyFilter = function () {
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            // $.spinner().start();
            $(this).trigger('search:filter', e);
            var currentUrl = $(this).data('href');
            var action = $(this).data('action');
            var attributeId = '#' + $(this).find('span').last().attr('id');
            var hostURL = window.location.href;
            var refinedURL = hostURL.split('?')[0] +'?'+ currentUrl.split('?')[1];
            var urlObj = new URL(hostURL);
            var srulevalue = urlObj.searchParams.get("srule");
            if(srulevalue != null && srulevalue != undefined && action != 'reset'){
                refinedURL = refinedURL + '&srule=' + srulevalue;
                currentUrl = currentUrl + '&srule=' + srulevalue;
                $('.sort-text').addClass('d-none');
            }
            $.ajax({
                url: currentUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href')
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    // $.spinner().stop();
                    $(attributeId).parent('button').focus();
                    window.history.replaceState({}, null, refinedURL);
                    // handle toggle refinement block - Mobile Viewport
                    $('.refinements-mobile-clp').on('click', '.refinement-header', function (e) {
                        e.stopPropagation();
                        $(this).toggleClass('active');
                    });
                },
                error: function () {
                    // $.spinner().stop();
                    $(attributeId).parent('button').focus();
                }
            });
        });
} 

/**
 * Code for view more and view less button
 */
baseSearch.viewMoreHideShow = function () {

    $(document).on('click','.refinement-less-more', function(e){
        var $hideShowLis = $(this).closest('.card-body').find('.hide-show-li');
        var $this = $(this);
        if($hideShowLis.hasClass('d-none')){
            $hideShowLis.removeClass('d-none');
            $this.html($this.data('viewless'));
        } else {
            $hideShowLis.addClass('d-none');
            $this.html($this.data('viewmore'));
        }
    });
};

var updateImpressions = function () {
    if (window.analyticsJSON && window.analyticsJSON.PRODUCT) {
      var impressions = [];
      $('#product-search-results .product-tile').each(function () {
        impressions.push(JSON.parse($(this).attr('data-tagdata')));
      });
      window.analyticsJSON.PRODUCT = impressions;
    }
};

/*
 * this will update the ensighten data layer object
 */
baseSearch.updateImpressions = updateImpressions;

/**
 * Display refinements bar when Menu icon clicked
 */
baseSearch.filter = function () {
    $('.container').on('click', 'button.filter-results', function () {
        $('.refinement-bar, .modal-background').show();
        $('.refinement-bar').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('body').addClass('mobile-filter-open');
        $('.refinement-bar .close').focus();
    });
};

/**
 * Refinements close button
 */
baseSearch.closeRefinements = function () {
    $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
        $('.refinement-bar, .modal-background').hide();
        $('.refinement-bar').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('body').removeClass('mobile-filter-open');
        $('.btn.filter-results').focus();
    });
};


baseSearch.pagination = function () {
    $(window).on('popstate', function () {
        if (history.state && 'search' === history.state.name) {
            window.location = location.href;
        }
    });

    // Show more products
    $(document).on('click', '.pagination-link, .pagination-arrow-step, .pagination-arrow', function (e) {
        e.stopPropagation();
        var paginationURL = $(this).attr('href');
        var currentURL = $(this).data('current-url');
        e.preventDefault();

        $.spinner().start();
        $.ajax({
            url: paginationURL,
            data: { selectedUrl: paginationURL },
            method: 'GET',
            success: function (response) {
                if (location.href.indexOf('sz=') === -1) {
                    history.replaceState({name: 'search'}, '', location.href);
                }
                history.pushState({name: 'search'}, '', currentURL);
                $('.product-grid').html(response);
                updateSortOptions(response);
                updateImpressions();
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

baseSearch.showMore = function () {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        e.preventDefault();

        // $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $('.grid-footer').replaceWith(response);
                updateSortOptions(response);
                updateImpressions();
                // $.spinner().stop();
            },
            error: function () {
                // $.spinner().stop();
            }
        });
    });
}

baseSearch.sort = function () {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        // $.spinner().start();
        $(this).trigger('search:sort', this.value);
        var hostURL = window.location.href;
        var urlObj = new URL(this.value);
        var srulevalue = urlObj.searchParams.get("srule");
        var langVal = urlObj.searchParams.get("lang");
        var pageUrl = '';
        if(srulevalue != null && srulevalue != undefined){
            urlObj.searchParams.set("srule", srulevalue);
            pageUrl = hostURL.split('?')[0] + urlObj.search;
            $('.sort-text').addClass('d-none');
        } else {
            pageUrl = hostURL + '&srule=' +  srulevalue;
        }

        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                $('.product-grid').empty().html(response);
                // $.spinner().stop();
                window.history.replaceState({}, null, pageUrl);
            },
            error: function () {
                // $.spinner().stop();
            }
        });
    });
}

baseSearch.windowLoad = function () {
    $(window).on('load', function () {
        var hostURL = window.location.href;
        var urlObj = new URL(hostURL);
        var srulevalue = urlObj.searchParams.get("srule");
        if(srulevalue != null && srulevalue != undefined){
            $('.sort-text').addClass('d-none');
        }

        $('.js-no-search-results').on('click', '.refinement-header', function () {
            $(this).toggleClass('active');
        });
    });
}

module.exports = baseSearch;
